import React, { useState, useEffect, useRef } from 'react'
import DataTable from '../../../Components/DataTable/DataTable';
import { Button, Modal, FormGroup, Form, Label, Input, ModalBody, Row, Col } from 'reactstrap';
import "../../pages.css"
import Header from '../../../Layout/Admin/Header';
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enGB } from "date-fns/locale";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import withAuth from "../../../Components/CheckSessionStorage/sessionUtils";
import apiRequest from '../../../api';

const AdminLots = () => {
    const selectedLanguageRef = useRef(localStorage.getItem('Language'));

    const columns_en = [{ title: 'Parking lots', key: "lot" }];
    const columns_rs = [{ title: 'Parking mesta', key: "lot" }];

    const [columns, setColumns] = useState(() => {
        return (selectedLanguageRef.current === "EN" ? columns_en : columns_rs);
    });

    useEffect(() => {
        // Handle changes from other tabs/windows and local changes
        const handleLanguageChange = (event) => {
            selectedLanguageRef.current = event.detail['selectedLanguage'];
            setColumns(selectedLanguageRef.current === "EN" ? columns_en : columns_rs)
        };

        window.addEventListener('languageChange', handleLanguageChange);
        return () => {
            window.removeEventListener('languageChange', handleLanguageChange);
        };
    }, []);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true); // To manage loading state
    const [error, setError] = useState(null); // To manage error state


    const [modalOpen, setModalOpen] = useState(false);
    const [formDetails, setFormDetails] = useState({
        lot:"",
    });
    const [errors, setErrors] = useState({
        lot: "",
    });
    const [filterText, setFilterText] = useState(""); // State to store the input value
    const [filteredData, setFilteredData] = useState([]); // State to store filtered results

    // Function to handle input change
    const handleFilterChange = (e) => {
        const value = e.target.value; // Convert input to lowercase for case-insensitive filtering
        setFilterText(value);
        // Filter data based on the input value
        filterData(value, data);
    };

    const filterData = (value, data) => {
        const filtered = data.filter((item) =>
            item.lot.startsWith(value) // Filter by 'username' starting with the input
        );
        setFilteredData(filtered);
    };

    const toggleModal = (e) => {
        e.preventDefault()
        setFormDetails({
            lot: "",
        });
        setErrors({
            lot: "",
        })
        setModalOpen(!modalOpen)
    };

    const handleInputChange = (e, field) => {
        const { name, value } = e.target; 

        formDetails[name] = value;

        setFormDetails({ ...formDetails });
    };

    const handleModalSubmit = async (e) => {
        e.preventDefault()
        const newErrors = {
            lot: formDetails.lot === "" ? "This field is required" : "",
        };
        setErrors({
            ...newErrors
        });

        if (newErrors.lot) {
            return;
        }
        const requestBody = {
            parkingLot:formDetails.lot,
        };

        // Make the POST request
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
            const response = await apiRequest('/api/parking_lots/create_lot', 'POST', requestBody, token);

            // Handle the response
            console.log("Lot created successfully:", response);
            fetchLot();
            setModalOpen(false); // Close the modal after successful submission

        } catch (error) {
            alert(error);
        }
    };

    const fetchLot = async () => {
        console.log("Usao u fetch");
        try {
            // Retrieve JWT from localStorage
            const token = sessionStorage.getItem("jwt");

            const users = await apiRequest(`/api/parking_lots/get_all`, 'GET', null, token);

            const formattedData = users.map((lot) => {

                return {
                    lot: lot.parkingLot
                };
            });
            const sortedData = [...formattedData].sort((a, b) => a.lot - b.lot);
            setData(sortedData);
            filterData(filterText, sortedData);
            console.log("Data:", sortedData);
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true); // Start loading
            await fetchLot(); // Fetch data
            setLoading(false); // Stop loading
        };

        fetchData();
    }, []); // Runs only once when the component is mounted



    if (loading) {
        return <Header />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();  // Prevent the Enter key from submitting the form
        }
    };
    return (
        <React.Fragment>
            <Header />

            <div className='container   lots' >
                <div className='table-container-1' >
                    <Row className="my-3">
                        <Col xs={8} md="9" className="text-end d-flex justify-content-end pe-1 pe-md-5 ">
                            <div className=" form-group position-relative filter_input d-flex align-items-center ">
                                <img
                                    src="/assets/icons/search.svg"
                                    alt="Calendar Icon"
                                    className="calendar-icon"
                                />
                                <input
                                    name="filter"
                                    type="text"
                                    className="form-control custom-input "
                                    placeholder={selectedLanguageRef.current === 'EN'?"Filter Lots...":"Pretraga..."}
                                    value={filterText} // Bind input value to state
                                    onChange={handleFilterChange} // Call the filter function on input change
                                />
                            </div>
                        </Col>
                        <Col
                        xs={4}
                            md="3"
                            className=" d-flex align-items-center justify-content-end text-center text-md-start  "
                        >
                            <div className='  btn-container d-flex justify-content-end justify-content-md-start  '   >
                                <Button onClick={toggleModal} className='add-btn'  >+</Button>
                            </div>
                        </Col>
                    </Row>
                    <div  className='row' style={{ justifyContent: "center" }} >
                       <div className='col-md-4 px-1' >

                            <DataTable fetchReservations={() => fetchLot()} data={filteredData}  columns={columns}/>
                       </div>
                       
                    </div>
                </div>
                {/* <div className='pt-1 pb-5 text-end btn-container mx-5 d-flex justify-content-center justify-content-md-end' style={{ width: "83%" }}  >
                <Button className='show-btn' onClick={handleShowMore} >{ visibleRows>=data.length?"Show less": "show more"}</Button> 
                </div> */}
            </div>
            <Modal
                isOpen={modalOpen}
                toggle={toggleModal}
                centered
                
                className="account_modal custom-model" 
            >
                <ModalBody className="pt-2">
                    <Form onKeyDown={handleKeyDown}>
                        <div className="row justify-content-end ">
                            <div className="col-md-2">
                                <button type="button" className="btn-close" onClick={toggleModal} />
                            </div>
                        </div>
                        <div className="row justify-content-center mb-5">
                            <div className="col-md-8">
                                <FormGroup>
                                    <Label className='label' >
                                        {selectedLanguageRef.current === 'EN' ? "Parking Lot":"Parking mesto"} <strong className="text-danger">*</strong>
                                    </Label>
                                    <Input
                                        type="text"
                                        name="lot"
                                        value={formDetails.lot}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <FormGroup>
                            <div className="row">
                                <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                    <button
                                        className=" model-btn-cancel btn btn-secondary rounded-2 py-1 px-5"
                                        onClick={toggleModal}
                                        type="button"
                                    >
                                        {selectedLanguageRef.current === 'EN' ? "Cancel":"Otkaži"}
                                    </button>
                                </div>
                                <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                    <button
                                        className=" model-btn btn btn-primary rounded-2 py-1 px-5"
                                        onClick={handleModalSubmit}
                                        type="button"
                                    >
                                        {selectedLanguageRef.current === 'EN' ? "Create":"Dodaj"}
                                    </button>
                                </div>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default withAuth(AdminLots);